import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { IOfficeField } from '@pages/office/models/office-data.model';
import { ControlErrorsMessagesOverridesRegistryModel } from './models/control-custom-errors.model';
import { FormHelper } from '../../../../shared/helpers/form.helper';
import { ControlErrorTextPipe } from './control-error-text.pipe';
import { MergePipe } from '../pipes/merge.pipe';
import { DEFAULT_CONTROL_ERROR_MESSAGES } from './control-errors.constant';

@Component({
  selector: 'app-control-errors',
  templateUrl: 'control-errors.component.html',
  styleUrls: ['control-errors.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ControlErrorTextPipe, MergePipe],
})
export class FormControlErrorsComponent implements OnInit {
  @Input({ required: true }) control: AbstractControl;
  @Input({ required: true }) officeField: IOfficeField;
  @Input() errorsMessagesOverridesRegistry: ControlErrorsMessagesOverridesRegistryModel;

  public controlErrors$: Observable<ValidationErrors | null>;
  public isTouched$: Observable<boolean>;
  public defaultControlErrorMessagesOverrides: ControlErrorsMessagesOverridesRegistryModel;

  public ngOnInit(): void {
    this.defaultControlErrorMessagesOverrides = DEFAULT_CONTROL_ERROR_MESSAGES(this.officeField);
    this.defineStatusChangesStreams();
  }

  private defineStatusChangesStreams(): void {
    const statusChanges$ = FormHelper.getControlAllStatusChanges(this.control);

    this.controlErrors$ = statusChanges$.pipe(map(() => this.control.errors));
    this.isTouched$ = statusChanges$.pipe(
      map(() => this.control.touched),
      distinctUntilChanged()
    );
  }
}
